//Servicios 
import HttpClienteSeguroCore from '../../Servicios/HttpClienteSeguroCore';
import HttpClienteSeguroParametros from '../../Servicios/HttpClienteSeguroParametros';

const obtieneCodigoIdiomas = () => {
    const etiIdioma = window.localStorage.getItem("etiqueta_idioma_Estudiante_CIF");
    return etiIdioma;
};

// Se encacarga de listar codigos sistema por id o por código
//codeId: id del tipo a buscar, puede ir vacio si se envia el codeTipo
//codeTipo: codigo del tipo a buscar, puede ir vacio si se envia el codeId
//idCompania: id compañía
//idRelacionado: id del registro vinculado, cuando aplique, sino enviar vacio
//estado: estado de los registros activos o inactivos, enviar true o false
export const ObtenerListadoRegistrosGenericos = (codeId, codeTipo, idCompania, idUsuario, idRelacionado, estado) => {
    const etiIdioma = obtieneCodigoIdiomas();
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/CodigosSistema/ListaRegistros/', {
            CodSystemCodeId: codeId, CodCode: codeTipo,
            CompanyId: idCompania, UserId: idUsuario, RelatedId: idRelacionado, Status: estado, Idioma: etiIdioma
        }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};


// Se encacarga de listar los tipos codigos sistema 
//idCompania: id compañía
//idUsuario: id usuario logueado
//filtro: filtro de busqueda
export const ObtenerListadoTiposCodigosSistema = (filtro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/CodigosSistema/ListaTipos/', filtro).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};


// metodo para crear nuevo registro, recibe:
//const objetoRegistro = {
//    SystemCodeId: id del tipo de registro,
//    CompanyId: id del la compañía en sesión del usuario,
//    DescriptionItem: descripción del registro,
//    RelatedIdItem: id del registro padre cuando aplique, sino enviar vacio,
//    UserId: id del usuario logueado
//};
export const CrearNuevoRegistroGenericoPorUsuario = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post("/CodigosSistema/Crear/", registro).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

/**
 * Se encarga de listar registros de tablas de sistema para campos dinamicos.
 * @param {{fieldId:string,filterValue:string,peticionUsuario:{ companyId:string, userId:string, optionId:string, action:string }}} objectRequest
 * @returns {Promise}
 */
export const ObtenerListadoRegistrosTablaSistema = (objectRequest) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroParametros.post('/CamposDinamicos/Campos/ListarRegistrosTablaSistema', objectRequest).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};




export default ObtenerListadoRegistrosGenericos;
